import actions from "./actions";

const initState = {
  blog: {},
  loading: false,
  errorMessage: null,
};

export default function createOrUpdateBlogReducer(state = initState, action) {
  switch (action.type) {
    case actions.CREATE_OR_UPDATE_BLOG_REQUESTED:
      return {
        ...state,
        blog: {},
        loading: true,
      };
    case actions.CREATE_OR_UPDATE_BLOG_SUCCEEDED:
      return {
        ...state,
        blog: action.blog,
        loading: false,
      };
    case actions.CREATE_OR_UPDATE_BLOG_FAILED:
      return {
        ...state,
        loading: false,
        errorMessage: action.error,
      };
    default:
      return state;
  }
}
